import { VariableValue } from '@components/text-editors/addons/field-mapping';

import { request } from '../request';

export type JourneyActionReminder = {
  journeyAction?: string;
  shortId: string;
  emailNotify: boolean;
  smsNotify: boolean;
  emailData?: ReminderEmailData;
  smsData?: ReminderSmsData;
  days: string;
  hours: string;
  minutes: string;
  frequency?: string;
  amount?: string;
};

export type TravellerActionReminder = {
  travellerAction?: string;
  shortId?: string;
  emailNotify: boolean;
  smsNotify: boolean;
  emailData?: ReminderEmailData;
  smsData?: ReminderSmsData;
  days: string;
  hours: string;
  minutes: string;
  frequency: string | null;
  amount: string | null;
};

export type ReminderEmailData = {
  content?: VariableValue;
  subject?: { value: string };
  recipients?: VariableValue[];
};

export type ReminderSmsData = {
  message?: VariableValue;
  recipients?: VariableValue[];
};

export type ReminderSchedule = {
  id: number;
  travellerAction: string;
  reminderData: ReminderEmailData | ReminderSmsData;
  method: string;
  scheduledDate: string;
  status: 'not_started' | 'in_progress' | 'sent' | 'completed' | 'failed' | 'skipped';
  isAutomatic: boolean;
  dateSucceeded: string | null;
  dateFailed: string | null;
  statusMessage: string | null;
};

export type newReminderSchedule = {
  travellerAction: string;
  method: string;
  scheduledDate: string;
  isAutomatic: boolean;
};

export const createJourneyActionReminder = async (reminder: JourneyActionReminder) => {
  const response = await request.post('v1/reminders/journey-reminders/', reminder);
  return response.data;
};

export const updateJourneyActionReminder = async (
  shortId: string,
  reminder: JourneyActionReminder
) => {
  const response = await request.patch(`v1/reminders/journey-reminders/${shortId}/`, reminder);
  return response.data;
};

export const deleteJourneyActionReminder = async (shortId: string) => {
  const response = await request.delete(`v1/reminders/journey-reminders/${shortId}/`);
  return response.data;
};

export const createTravellerActionReminder = async (reminder: TravellerActionReminder) => {
  const response = await request.post('v1/reminders/traveller-reminders/', reminder);
  return response.data;
};

export const updateTravellerActionReminder = async (
  shortId: string,
  reminder: TravellerActionReminder
) => {
  const response = await request.patch(`v1/reminders/traveller-reminders/${shortId}/`, reminder);
  return response.data;
};

export const deleteTravellerActionReminder = async (shortId: string) => {
  const response = await request.delete(`v1/reminders/traveller-reminders/${shortId}/`);
  return response.data;
};

export const createManualReminder = async (reminder: any) => {
  const response = await request.post('v1/reminders/reminder-schedules/', reminder);
  return response.data;
};
